// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2IosW","buttons":"RemoveExpirationActionButtons_buttons__2bEzq"};